import * as React from "react"

interface IconProps {
  color?: string
}

export const ArrowButtonUp: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.5 43.5C10.902 43.5 1.5 34.098 1.5 22.5C1.5 10.902 10.902 1.5 22.5 1.5C34.098 1.5 43.5 10.902 43.5 22.5C43.5 34.098 34.098 43.5 22.5 43.5Z"
      stroke={color}
      strokeWidth="3"
    />
    <path
      d="M13.4839 25.0161L22.5 16L31.5161 25.0161L29.9157 26.6165L22.5 19.2007L15.0842 26.6165L13.4839 25.0161Z"
      fill={color}
    />
  </svg>
)

export const ArrowButtonRight: React.FunctionComponent<IconProps> = ({ color = "#262626" }) => (
  <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 22.5C1.5 10.902 10.902 1.5 22.5 1.5C34.098 1.5 43.5 10.902 43.5 22.5C43.5 34.098 34.098 43.5 22.5 43.5C10.902 43.5 1.5 34.098 1.5 22.5Z"
      stroke={color}
      strokeWidth="3"
    />
    <path
      d="M19.9839 13.4839L29 22.5L19.9839 31.5161L18.3835 29.9157L25.7993 22.5L18.3835 15.0842L19.9839 13.4839Z"
      fill={color}
    />
  </svg>
)

export const ArrowButtonLeft: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22.5" cy="22.5" r="21" stroke={color} strokeWidth="3" />
    <path
      d="M25.0161 31.5161L16 22.5L25.0161 13.4839L26.6165 15.0842L19.2007 22.5L26.6165 29.9158L25.0161 31.5161Z"
      fill={color}
    />
  </svg>
)

export const ArrowButtonDown: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22.5" cy="22.5" r="21" transform="rotate(-90 22.5 22.5)" stroke={color} strokeWidth="3" />
    <path
      d="M31.5161 19.9839L22.5 29L13.4839 19.9839L15.0842 18.3835L22.5 25.7993L29.9158 18.3835L31.5161 19.9839Z"
      fill={color}
    />
  </svg>
)
